import { useEffect, useMemo, useState } from 'react';
import { deriveFilterState, trimFiltersToState } from '../utils/filtersLogic';

export default function useFiltersState(graph) {
  const [filters, setFilters] = useState({ operator: [], unit: [], meter: [] });
  const state = useMemo(() => deriveFilterState(graph, filters), [graph, filters]);

  useEffect(() => {
    setFilters((prev) => trimFiltersToState(prev, state));
  }, [state]);

  return { filters, setFilters, state };
}
